/* Favoris — Le Temple du Foot (28/10/2026)
   Cœur sur les cartes produit (grilles du thème + sections maison), compteur dans le header, tiroir « Mes favoris ».
   Stockage local au navigateur (localStorage ltdf_wish), aucune appli. */
(function(){
  var KEY='ltdf_wish';
  function load(){try{var a=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(a)?a:[];}catch(e){return [];}}
  function save(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  var list=load();
  function has(h){return list.indexOf(h)>-1;}
  function toggle(h){var i=list.indexOf(h);if(i>-1)list.splice(i,1);else list.unshift(h);save(list);sync();return i===-1;}
  function handleFrom(href){var m=(href||'').match(/\/products\/([a-z0-9\-_%.]+)/i);return m?m[1].split('?')[0]:null;}

  var HEART='<svg viewBox="0 0 24 24"><path d="M12 20.5s-7.5-4.6-7.5-10A4 4 0 0 1 12 8a4 4 0 0 1 7.5 2.5c0 5.4-7.5 10-7.5 10z"/></svg>';

  /* ---------- cœurs sur les cartes ---------- */
  function cards(){
    document.querySelectorAll('.product-card:not([data-lx-wish])').forEach(function(card){
      card.setAttribute('data-lx-wish','1');
      var link=card.querySelector('.product-card__link, a[href*="/products/"]');var h=handleFrom(link&&link.getAttribute('href'));if(!h)return;
      var gal=card.querySelector('.card-gallery')||card;addHeart(gal,h);
    });
    document.querySelectorAll('a.td-carte:not([data-lx-wish]),a.pc-carte:not([data-lx-wish]),a.ke-carte:not([data-lx-wish]),a.ed-carte:not([data-lx-wish]),a.lx-pcard:not([data-lx-wish])').forEach(function(a){
      a.setAttribute('data-lx-wish','1');var h=handleFrom(a.getAttribute('href'));if(!h)return;
      var img=a.querySelector('.td-img,.pc-img,.ke-img,.ed-img,.lx-pimg')||a;addHeart(img,h);
    });
  }
  function addHeart(host,h){
    if(host.querySelector(':scope > .lx-heart'))return;
    var b=document.createElement('button');b.type='button';b.className='lx-heart'+(has(h)?' is-on':'');b.setAttribute('data-handle',h);b.setAttribute('aria-label',has(h)?'Retirer des favoris':'Ajouter aux favoris');b.innerHTML=HEART;
    b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var on=toggle(h);b.classList.toggle('is-on',on);b.classList.remove('is-pop');void b.offsetWidth;b.classList.add('is-pop');b.setAttribute('aria-label',on?'Retirer des favoris':'Ajouter aux favoris');if(on)bump();});
    if(getComputedStyle(host).position==='static')host.style.position='relative';
    host.appendChild(b);
  }
  function sync(){
    document.querySelectorAll('.lx-heart').forEach(function(b){b.classList.toggle('is-on',has(b.getAttribute('data-handle')));});
    var c=document.querySelector('.yk-wish-count');if(c){c.textContent=String(list.length);c.hidden=list.length===0;}
    if(drawer&&!drawer.hidden)render();
  }
  function bump(){var c=document.querySelector('.yk-wish-count');if(c){c.classList.remove('is-pop');void c.offsetWidth;c.classList.add('is-pop');}}

  /* ---------- header ---------- */
  function header(){
    var icons=document.querySelector('.yk-icons');if(!icons||icons.querySelector('.yk-wish-btn'))return;
    var b=document.createElement('button');b.type='button';b.className='yk-icon-btn yk-wish-btn';b.setAttribute('aria-label','Mes favoris');
    b.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20.5s-7.5-4.6-7.5-10A4 4 0 0 1 12 8a4 4 0 0 1 7.5 2.5c0 5.4-7.5 10-7.5 10z"/></svg><span class="yk-wish-count" hidden>0</span>';
    var cart=icons.querySelector('#ltdfCartBtn');if(cart)icons.insertBefore(b,cart);else icons.appendChild(b);
    b.addEventListener('click',open);
  }

  /* ---------- tiroir ---------- */
  var drawer=null;
  function build(){
    if(drawer)return drawer;
    drawer=document.createElement('div');drawer.className='lx-wish';drawer.hidden=true;drawer.setAttribute('role','dialog');drawer.setAttribute('aria-modal','true');drawer.setAttribute('aria-label','Mes favoris');
    drawer.innerHTML='<div class="lx-wish-bg"></div><div class="lx-wish-panel"><div class="lx-wish-head"><h3>Mes favoris<small></small></h3><button type="button" class="lx-x" aria-label="Fermer">&times;</button></div><div class="lx-wish-list"></div><div class="lx-wish-foot"><a href="/collections/all">Continuer mes achats</a></div></div>';
    document.body.appendChild(drawer);
    drawer.querySelector('.lx-wish-bg').addEventListener('click',close);drawer.querySelector('.lx-x').addEventListener('click',close);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer&&!drawer.hidden)close();});
    return drawer;
  }
  function open(){build();drawer.hidden=false;document.documentElement.style.overflow='hidden';requestAnimationFrame(function(){drawer.classList.add('is-on');});render();}
  function close(){if(!drawer)return;drawer.classList.remove('is-on');setTimeout(function(){drawer.hidden=true;document.documentElement.style.overflow='';},220);}
  var cache={};
  function money(c){return (c/100).toFixed(2).replace('.',',')+' €';}
  function render(){
    var box=drawer.querySelector('.lx-wish-list'),small=drawer.querySelector('.lx-wish-head small');
    small.textContent=list.length?(list.length+' article'+(list.length>1?'s':'')):'';
    if(!list.length){box.innerHTML='<div class="lx-wish-empty"><b>Rien pour l’instant</b>Touche le cœur sur un maillot pour le garder ici.</div>';return;}
    box.innerHTML='';
    list.forEach(function(h){
      var row=document.createElement('div');row.className='lx-wish-item';row.setAttribute('data-h',h);
      row.innerHTML='<img alt="" src=""><div class="t"><a href="/products/'+h+'">…</a><span class="p"></span></div><button type="button" class="rm" aria-label="Retirer">&times;</button>';
      row.querySelector('.rm').addEventListener('click',function(){toggle(h);});
      box.appendChild(row);
      fill(row,h);
    });
  }
  function fill(row,h){
    function apply(p){var img=row.querySelector('img');if(p.featured_image)img.src=p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2');row.querySelector('.t a').textContent=p.title;var v=p.variants&&p.variants[0];if(v)row.querySelector('.p').textContent=money(v.price);}
    if(cache[h]){apply(cache[h]);return;}
    fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){if(!p){row.querySelector('.t a').textContent=h;return;}cache[h]=p;apply(p);}).catch(function(){row.querySelector('.t a').textContent=h;});
  }

  function boot(){header();cards();sync();new MutationObserver(function(){cards();header();}).observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
